import React, { useState } from 'react';
import { noop } from 'lodash';
import styled from '@emotion/styled';
import { createPhoneURI } from 'hooks/useDisplayPhone';
import PhoneIcon from 'assets/svg/phone-1-5.svg';
import { useLocale } from 'locale';
import { Button } from 'ds/components/button';

export const PhoneButton = styled(Button.withComponent('a'))<{ fullWidth?: boolean; }>`
  text-decoration: none;
  display: flex;
  flex-grow: 0;
  white-space: nowrap;
  ${({ fullWidth }) => `
    flex-basis: ${fullWidth ? '100%' : '185px'};
  `}
`;

interface PhoneButtonBaseProps {
  phone: string;
  label?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large' | 'extraLarge' | 'extraXLarge';
  mode?: 'primary' | 'ghost' | 'primaryNegative' | 'dark' | 'ghost-dark' | 'ghost-dark-grey';
  onPhoneNumberShow?: (isVisible: boolean) => void;
  exposePhone?: boolean;
}


const PhoneButtonBase: React.FC<PhoneButtonBaseProps> = (props) => {
  const { phone, label, fullWidth, size = 'extraLarge', mode = 'ghost', onPhoneNumberShow = noop, exposePhone = true } = props;
  const [ phoneNumberIsVisible, setPhoneNumberIsVisible ] = useState(false);
  const { t } = useLocale();

  if (!phone) return null;

  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    onPhoneNumberShow(phoneNumberIsVisible);
    if (!phoneNumberIsVisible && exposePhone) {
      e.preventDefault();
      setPhoneNumberIsVisible(true);
    }
  };
  const btnLabel = phoneNumberIsVisible && exposePhone ? phone : (label ||  t('contactForm.contact.form.withMortgage.phoneButton', { isMobile: false }));
  return (
    <PhoneButton
      data-auto="phone-number-button"
      mode={mode}
      size={size}
      onClick={onClick}
      href={createPhoneURI(phone)}
      fullWidth={fullWidth}
    >
      <PhoneIcon />
      {btnLabel}
    </PhoneButton>
  );
};

export default PhoneButtonBase;
